import { businessApiRoute, post } from './Api';
import useDeleteApi from './useDeleteApi';
import type { ApiOptions } from './Types';

export default function (route: string, opts?: ApiOptions) {
    return useDeleteApi(businessApiRoute(route), opts);
}
